import React, { useCallback, useEffect, useState } from 'react';

const CheckboxFilterKeywords = ({handleParams, params, label, keyName}) => {
	
	const checkIsSet = useCallback(()=>{
		const keywords = params.get('keywords')?.split(' ') ?? []
		return keywords.includes(keyName)
	},[params, keyName])
	

	const [state, setState] = useState(checkIsSet());


	useEffect(()=>{
		const keywords = params.get('keywords')?.split(' ') ?? []
		const isSet = keywords.includes(keyName)

		// remove
		if ( isSet && !state ) {

			// filter out keyName
			const newKeywords = keywords.filter(k => k !== keyName)
			const newParams = new URLSearchParams( params.toString() )
			
			newKeywords.length > 0
				? newParams.set('keywords', newKeywords.join(' ') )
				: newParams.delete('keywords')
	
			handleParams(newParams)
		// add
		} else if( state && !isSet ) {

			const newKeywords = keywords
			newKeywords.push(keyName)
			const newParams = new URLSearchParams(params.toString())
			
			newParams.set('keywords', newKeywords.join(' ') )
	
			handleParams(newParams)

		}
	},[state])

	useEffect( () => {
		// const isSet = checkIsSet();
		const tmpKeywords =  params.get('keywords')?.split(' ') ?? []

		if(tmpKeywords.includes(keyName) !== state) {
			setState(tmpKeywords.includes(keyName) )
		}
	},[params])

	return (
		<div className={`checkbox-wrapper${state ? ' active':''}`}>
			<input defaultChecked={ state } id={keyName} value='true' type="checkbox" name={keyName} />
			<label 
				htmlFor={keyName}
				onClick={()=>{
					setState( !state )
				}}
				>{label}</label>
		</div>
	)
}

export default CheckboxFilterKeywords;